import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowLeftCircleStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12ZM22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12Z"
				fill="currentColor"
			/>
			<path
				d="M9.96973 8.96973C10.2626 8.67685 10.7374 8.67687 11.0303 8.96973C11.3231 9.2626 11.3231 9.73737 11.0303 10.0303L9.81055 11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H9.81055L11.0303 13.9697L11.082 14.0264C11.3223 14.3209 11.3048 14.7557 11.0303 15.0303C10.7557 15.3049 10.321 15.3223 10.0264 15.082L9.96973 15.0303L7.46973 12.5312C7.32906 12.3906 7.25002 12.1989 7.25 12C7.25011 11.8013 7.32919 11.6103 7.46973 11.4697L9.96973 8.96973Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowLeftCircleStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowLeftCircleStrokeIcon;
